import { render, staticRenderFns } from "./MonthAllowancesPlans.vue?vue&type=template&id=2391d788&"
import script from "./MonthAllowancesPlans.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports